import React from 'react';
import { motion } from 'framer-motion';
import navImage from './images/nav.png';
import gridSocial from './images/grid-social.png';
import communityImage from './images/community-image.png';
import profileIcon from './images/profile-icon.png';
import toneOfVoice from './images/tone-of-voice.png';
import languageIcon from './images/language.png';
import smartAsset from './images/smart-asset.png';
import onePlatform from './images/one-platform.png';

export default function FeatureGrid() {
  return (
    <div className="bg-background-marketing w-full py-10 md:py-20">
      <div
        className="max-w-[1156px] mx-auto px-4 flex flex-col gap-4 md:grid md:grid-cols-6 tracking-wider font-normal"
        style={{
          gridTemplateRows: 'repeat(9, 76px)',
        }}
      >
        {/* Left tall card */}
        <div className="bg-background-main rounded-2xl flex flex-col justify-between overflow-hidden p-6 pb-0 md:p-8 md:pb-0 min-h-[456px] md:h-auto md:col-span-2 md:row-span-6">
          <h3 className="text-xl text-text-primary text-center mb-4">
            AI-powered creative suite
            <br /> for every need
          </h3>
          <div className="w-full mt-auto">
            <motion.img
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true, amount: 0.3, margin: '-100px' }}
              transition={{ duration: 0.6 }}
              src={navImage}
              alt="nav"
              className="mx-auto w-full object-contain overflow-hidden"
            />
          </div>
        </div>

        {/* Middle top card */}
        <div className="bg-background-main rounded-2xl flex flex-col justify-between p-6 pb-0 md:p-8 md:pb-0 min-h-[228px] md:h-auto md:col-span-2 md:row-span-3">
          <h3 className="text-xl text-text-primary text-center mb-4">
            Seamlessly integrated to
            <br /> third party apps
          </h3>
          <div className="w-full mt-auto">
            <motion.img
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              src={gridSocial}
              alt="grid-social"
              className="mx-auto w-full object-contain rounded-t-lg"
            />
          </div>
        </div>

        {/* Right top card */}
        <div className="bg-background-main rounded-2xl p-6 md:p-8 flex items-center justify-between min-h-[152px] md:h-auto md:col-span-2 md:row-span-2">
          <h3 className="text-xl text-text-primary text-left">
            Personalized dashboards
          </h3>
          <div>
            <motion.img
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              src={profileIcon}
              alt="profile-icon"
            />
          </div>
        </div>

        <div className="bg-background-main rounded-2xl p-6 md:p-8 flex items-center justify-between min-h-[152px] md:h-auto md:col-span-2 md:row-span-2">
          <h3 className="text-xl text-text-primary text-left">
            Brand void & <br /> style controls
          </h3>
          <div>
            <motion.img
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              src={toneOfVoice}
              alt="tone-of-voice"
            />
          </div>
        </div>

        {/* Middle bottom card */}
        <div className="bg-background-main rounded-2xl flex flex-col justify-between p-6 pb-0 md:p-8 md:pb-0 min-h-[228px] md:h-auto md:col-span-2 md:row-span-3">
          <h3 className="text-xl text-text-primary text-center mb-4">
            Community and learning
            <br /> resources
          </h3>
          <div className="w-full mt-auto">
            <motion.img
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              src={communityImage}
              alt="community-image"
              className="mx-auto w-full object-contain rounded-t-lg"
            />
          </div>
        </div>

        <div className="bg-background-main rounded-2xl p-6 md:p-8 flex items-center justify-between min-h-[152px] md:h-auto md:col-span-2 md:row-span-2">
          <h3 className="text-xl text-text-primary text-left">
            Supporting 20+ languages
          </h3>
          <div>
            <motion.img
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              src={languageIcon}
              alt="language-icon"
            />
          </div>
        </div>

        {/* Right bottom card */}
        <div className="bg-background-main rounded-2xl p-6 md:p-8 flex items-center justify-between min-h-[228px] md:h-auto md:col-span-3 md:row-span-3">
          <h3 className="text-xl text-text-primary">
            One platform: create to
            <br />
            publish in minutes
          </h3>
          <motion.img
            initial={{ y: 100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            src={onePlatform}
            alt="one-platform"
            className="object-contain w-24 lg:w-auto"
          />
        </div>

        {/* Bottom right card */}
        <div className="bg-background-main rounded-2xl p-6 pb-0 md:p-8 md:pb-0 min-h-[228px] md:h-auto md:col-span-3 md:row-span-3 md:!pr-0 flex flex-col justify-between">
          <h3 className="text-xl text-text-primary text-center mr-2">
            Smart Asset Library & Organization
          </h3>
          <div className="mt-auto">
            <motion.img
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              src={smartAsset}
              alt="smart-asset"
              className="w-full object-contain rounded-br-2xl"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
